import env from "Consts/env";
import { handle498OnClient } from "Helpers/is498";
import { apiSlice } from "../api/apiSlice";
import { showModalVerify } from "@/Store/popup_modal_verify/lib/actions";

export const cartApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createCartWith498: builder.mutation({
			query: (body) => ({
				url: "/api/fds-cart/items",
				method: "POST",
				body,
				headers: {
					...env.HEADERS,
				},
			}),
			invalidatesTags: ["Products", "Badges"],
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				// Jika bukan 498, teruskan respons normal
				return { status: response?.status ?? response.meta.code, data: response };

			},
			validateStatus: (response) => response.status === 304
				|| (response.status >= 200 && response.status < 300),
			async onQueryStarted(arg, { dispatch, queryFulfilled }) {

				try {

					// Tunggu query selesai
					const { data } = await queryFulfilled;
					if (data?.data?.meta?.code === 401
						&& data?.data?.meta?.msg
						=== "Your email is missing, please add your email in the profile account setting.") {

						dispatch(showModalVerify({ showModalVerifyEmail: true }));

					}

				} catch (error) {

					console.error("Query failed:", error);

				}

			},
		}),
		mergeCartWith498: builder.mutation({
			query: (body) => ({
				url: "/api/fds-cart/merge",
				method: "POST",
				body,
				headers: {
					...env.HEADERS,
				},
			}),
			invalidatesTags: ["Products", "Badges"],
		}),
		getPromotionList: builder.query({
			query: (args) => ({
				url: "/api/fds-cart/promo",
				method: "get",
				headers: {
					...env.HEADERS,
				},
				params: args?.params,
			}),
		}),
		getPromotionDetail: builder.query({
			query: (args) => ({
				url: `/api/fds-cart/promo/${args?.id}`,
				method: "get",
				headers: {
					...env.HEADERS,
				},
				params: args?.params,
			}),
			async onQueryStarted(id, { dispatch, queryFulfilled }) {

				try {

					const response = await queryFulfilled;
					if (response?.data?.meta?.code === 498) {

						dispatch(handle498OnClient(response?.data));

					}

				} catch (err) {

					dispatch(handle498OnClient(err?.error?.data));

				}

			},
		}),
		getCartItem: builder.query({
			query: () => ({
				url: "/api/fds-cart/items",
				method: "get",
				headers: {
					...env.HEADERS,
				},
			}),
			async onQueryStarted(id, { dispatch, queryFulfilled }) {

				try {

					const response = await queryFulfilled;
					if (response?.data?.meta?.code === 498) {

						dispatch(handle498OnClient(response?.data));

					}

				} catch (err) {

					dispatch(handle498OnClient(err?.error?.data));

				}

			},
			providesTags: ["CART_ITEM"],
		}),
		getCartTotal: builder.query({
			query: () => ({
				url: "/api/fds-cart/total",
				method: "GET",
				headers: {
					...env.HEADERS,
				},
			}),
			async onQueryStarted(id, { dispatch, queryFulfilled }) {

				try {

					const response = await queryFulfilled;
					if (response?.data?.meta?.code === 498) {

						dispatch(handle498OnClient(response?.data));

					}

				} catch (err) {

					dispatch(handle498OnClient(err?.error?.data));

				}

			},
			providesTags: ["CART_TOTAL"],
		}),
		applyPromo: builder.mutation({
			query: (body) => ({
				url: `/api/fds-cart/coupons/${body?.item}`,
				method: "PUT",
				headers: {
					...env.HEADERS,
				},
			}),
			async onQueryStarted(id, { dispatch, queryFulfilled }) {

				try {

					const response = await queryFulfilled;
					if (response?.data?.meta?.code === 498) {

						dispatch(handle498OnClient(response?.data));

					}

				} catch (err) {

					dispatch(handle498OnClient(err?.error?.data));

				}

			},
			invalidatesTags: ["CART_TOTAL", "BROWSE_PROMOTION_LIST"],
		}),
		deletePromo: builder.mutation({
			query: (body) => ({
				url: `/api/fds-cart/coupons/${body?.item}`,
				method: "DELETE",
				headers: {
					...env.HEADERS,
				},
			}),
			async onQueryStarted(id, { dispatch, queryFulfilled }) {

				try {

					const response = await queryFulfilled;
					if (response?.data?.meta?.code === 498) {

						dispatch(handle498OnClient(response?.data));

					}

				} catch (err) {

					dispatch(handle498OnClient(err?.error?.data));

				}

			},
			invalidatesTags: ["CART_TOTAL", "BROWSE_PROMOTION_LIST"],
		}),
		updateCartItemAmountWith498: builder.mutation({
			query: (body) => ({
				url: `/api/fds-cart/items/${body?.id}`,
				method: "PUT",
				headers: {
					...env.HEADERS,
				},
				body,
			}),
			async onQueryStarted(id, { dispatch, queryFulfilled }) {

				try {

					const response = await queryFulfilled;
					if (response?.data?.meta?.code === 498) {

						dispatch(handle498OnClient(response?.data));

					}

				} catch (err) {

					dispatch(handle498OnClient(err?.error?.data));

				}

			},
			invalidatesTags: ["CART_ITEM", "CART_TOTAL", "Badges"],
		}),
		calculateShippingWith498: builder.mutation({
			query: (body) => ({
				url: "/api/fds-cart/calculate-shipping",
				method: "POST",
				body,
				headers: {
					...env.HEADERS,
				},
			}),
			async onQueryStarted(id, { dispatch, queryFulfilled }) {

				try {

					const response = await queryFulfilled;
					if (response?.data?.meta?.code === 498) {

						dispatch(handle498OnClient(response?.data));

					}

				} catch (err) {

					dispatch(handle498OnClient(err?.error?.data));

				}

			},
			invalidatesTags: ["CART_ITEM", "CART_TOTAL", "Badges"],
		}),
		deleteCartItemAmountWith498: builder.mutation({
			query: (body) => ({
				url: `/api/fds-cart/items/${body?.id}`,
				method: "DELETE",
				headers: {
					...env.HEADERS,
				},
			}),
			async onQueryStarted(id, { dispatch, queryFulfilled }) {

				try {

					const response = await queryFulfilled;
					if (response?.data?.meta?.code === 498) {

						dispatch(handle498OnClient(response?.data));

					}

				} catch (err) {

					dispatch(handle498OnClient(err?.error?.data));

				}

			},
			invalidatesTags: ["CART_ITEM", "CART_TOTAL", "Badges"],
		}),
		getBrowsePromotionList: builder.query({
			query: (params) => ({
				url: "/api/fds-cart/promo/browse",
				method: "get",
				headers: {
					...env.HEADERS,
				},
				params,
			}),
			providesTags: ["BROWSE_PROMOTION_LIST"],
			transformResponse: (response) => ({
				...response,
				currentSelected: response?.selected_data,
			}),
		}),
		getValidateCart: builder.query({
			query: () => ({
				url: "/api/fds-cart/validate",
				method: "get",
				headers: {
					...env.HEADERS,
				},
			}),
			async onQueryStarted(id, { dispatch, queryFulfilled }) {

				try {

					const response = await queryFulfilled;
					if (response?.data?.meta?.code === 498) {

						dispatch(handle498OnClient(response?.data));

					}

				} catch (err) {

					dispatch(handle498OnClient(err?.error?.data));

				}

			},
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				// Jika bukan 498, teruskan respons normal
				return response;

			},
			validateStatus: (response) => response.status === 304
				|| (response.status >= 200 && response.status < 300)
			,
		}),
		getMyOrder: builder.query({
			query: (params) => ({
				url: "/api/fds-order/mine",
				method: "GET",
				params,
				headers: {
					...env.HEADERS,
				},
			}),
			async onQueryStarted(id, { dispatch, queryFulfilled }) {

				try {

					const response = await queryFulfilled;
					if (response?.data?.meta?.code === 498) {

						dispatch(handle498OnClient(response?.data));

					}

				} catch (err) {

					dispatch(handle498OnClient(err?.error?.data));

				}

			},
			providesTags: ["MY_ORDER"],
		}),
	}),
});

export const {
	useCreateCartWith498Mutation,
	useMergeCartWith498Mutation,
	useGetPromotionListQuery,
	useGetPromotionDetailQuery,
	useGetCartItemQuery,
	useGetCartTotalQuery,
	useApplyPromoMutation,
	useDeletePromoMutation,
	useUpdateCartItemAmountWith498Mutation,
	useDeleteCartItemAmountWith498Mutation,
	useGetBrowsePromotionListQuery,
	useLazyGetValidateCartQuery,
	useCalculateShippingWith498Mutation,
	useGetMyOrderQuery,
} = cartApiSlice;
